import { useEffect } from "react";

export const MobileComTest = () => {
  useEffect(() => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: "mobileComTest",
        message: "This is a test message from the web app to the mobile app.",
      }),
    );
    console.log("Mobile communication test initiated.");
  }, []);

  return (
    <div className="my-4 text-center">
      <h5>A message as been sent to the mobile app</h5>
    </div>
  );
};
